import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import CircleButton from './CircleButton';

export default class GameSelect extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.titleLabel = this.scene.add.bitmapText(0, 3, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('select.title_2'), 36).setTintFill('0x980b0d')
      .setOrigin(.5);
    this.add(this.titleLabel);
    this.titleLabel.alpha = 0;

    this.optionWholeNumbers = new CircleButton(this.scene, this, 'BtnLblWholeNumbers', { bottomLblSprite: 'LblWholeNumbers' }).setAlpha(0);
    this.optionWholeNumbers.on('pointerup', () => { this.handleButtonClick(this.optionWholeNumbers); });

    this.optionFractions = new CircleButton(this.scene, this, 'BtnLblFractions', { bottomLblSprite: 'LblFractions' }).setAlpha(0);
    this.optionFractions.on('pointerup', () => { this.handleButtonClick(this.optionFractions); });

    this.optionDecimals = new CircleButton(this.scene, this, 'BtnLblDecimals', { bottomLblSprite: 'LblDecimals' }).setAlpha(0);
    this.optionDecimals.on('pointerup', () => { this.handleButtonClick(this.optionDecimals); });

    this.optionMixed = new CircleButton(this.scene, this, 'BtnLblMixed', { bottomLblSprite: 'LblMixed' }).setAlpha(0);
    this.optionMixed.on('pointerup', () => { this.handleButtonClick(this.optionMixed); });

    const s = 180;
    const centerOffset = 52;
    this.optionWholeNumbers.x = centerOffset;
    this.optionFractions.x = 1 * s + centerOffset;
    this.optionDecimals.x = 2 * s + centerOffset;
    this.optionMixed.x = 3 * s + centerOffset;
    this.optionWholeNumbers.y = this.titleLabel.height * 2 + 50;
    this.optionFractions.y = this.titleLabel.height * 2 + 50;
    this.optionDecimals.y = this.titleLabel.height * 2 + 50;
    this.optionMixed.y = this.titleLabel.height * 2 + 50;

    this.titleLabel.x = this.getBounds().width / 2 - this.titleLabel.width / 2 + 50;

    this.buttons = [this.optionWholeNumbers, this.optionFractions, this.optionDecimals, this.optionMixed];
    this.selectedButtonIndex = 0;
    this.buttons[0].select();
  }

  transitionIn() {
    let tweenwait = 0;
    ABCyaPhaser.Tweens.addTween(this.titleLabel, 220, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.dotPop(this.optionWholeNumbers, 420, tweenwait);
    tweenwait += 300;
    this.dotPop(this.optionFractions, 420, tweenwait);
    tweenwait += 300;
    this.dotPop(this.optionDecimals, 420, tweenwait);
    tweenwait += 300;
    this.dotPop(this.optionMixed, 420, tweenwait);
    tweenwait += 300;
    return tweenwait + 420;
  };

  handleButtonClick(target) {
    const i = this.buttons.indexOf(target);
    if (i !== this.selectedButtonIndex) {
      this.buttons[this.selectedButtonIndex].unselect();
    }
    this.selectedButtonIndex = i;
    this.buttons[this.selectedButtonIndex].select();
    this.emit('GAMETYPE_CHANGE', i);
    gameData.gametype = i;
  };

  dotPop(obj, time = 320, wait = 0) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scale: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  };
}